var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading-bullet _text-base _flex _items-center"},[_c('span',{staticClass:"_h-3 _w-3 _bg-white _mr-4 _mb-1"}),_c('div',{staticClass:"_leading-none"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }